import React, { useState } from 'react';
import profile from '../assets/profile.jpg';
import { FaArrowRight, FaEnvelope, FaFolderOpen, FaFileAlt } from 'react-icons/fa';

const Home = () => {
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <section className="hero-section position-relative overflow-hidden section pb-0">
      <div className="custom-hero-bg position-absolute top-0 start-0 w-100 h-100" aria-hidden="true" />
      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row align-items-center flex-column-reverse flex-md-row min-vh-80 justify-content-center g-5">
          {/* Text Side */}
          <div className="col-12 col-md-7 text-center text-md-start d-flex flex-column align-items-center align-items-md-start justify-content-center">
            <h1 className="display-4 fw-bold mb-2 hero-name" style={{ color: 'var(--about-primary, #1C1C1C)', letterSpacing: '0.01em' }}>
              Hi, I'm <span className="hero-accent">Utkarsh Srivastava</span>
            </h1>
            <h3 className="fw-semibold mb-3 hero-title" style={{ color: 'var(--about-accent, #2F80ED)' }}>
              Associate Software Engineer
            </h3>
            <p className="lead mb-4 hero-tagline" style={{ color: 'var(--about-secondary, #4F4F4F)', fontSize: '1.15rem', lineHeight: 1.7, maxWidth: 540 }}>
              Problem Solver | Tech Enthusiast | Passionate about creating scalable solutions and exploring new technologies.
            </p>
            <div className="d-flex flex-wrap gap-3 mt-2">
              <a href="#projects" className="btn btn-primary hero-btn d-flex align-items-center gap-2 shadow-sm">
                <FaFolderOpen /> Check My Work
              </a>
              <a href="#contact" className="btn btn-outline-primary hero-btn d-flex align-items-center gap-2 shadow-sm">
                <FaEnvelope /> Contact Me
              </a>
              <a href={process.env.PUBLIC_URL + '/Utkarsh_Srivastava_Resume.pdf'} className="btn btn-outline-primary hero-btn d-flex align-items-center gap-2 shadow-sm" download>
                <FaFileAlt /> View Resume
              </a>
            </div>
          </div>
          {/* Image Side */}
          <div className="col-12 col-md-5 d-flex justify-content-center align-items-center mb-4 mb-md-0">
            <div
              className={`hero-img-wrapper minimal ${imgLoaded ? 'fade-in' : ''}`}
              style={{ background: 'transparent', minWidth: 260, minHeight: 260, maxWidth: 340, maxHeight: 340, boxShadow: 'none', border: 'none', transition: 'none' }}
            >
              <img
                src={profile}
                alt="Utkarsh Srivastava"
                className="rounded-circle hero-img profile-img-animated minimal"
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%', border: 'none', boxShadow: 'none' }}
                onLoad={() => setImgLoaded(true)}
                onError={e => (e.target.style.display = 'none')}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
